<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input
          :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
          :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
          :value="value"
          :disabled="disabled || component.properties.readonly"
          :placeholder="component.properties.placeholder"
          @focus="controlClick(component, index)"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'

export default {
  name: 'rc-login-user',
  mixins: [ componentMixin, inputMixin ],
  props: [ 'component', 'value', 'disabled', 'labelParameter', 'index', 'tableCtrlKey' ],
  methods: {
    initComponent () {
      let deptId = ''
      let postId = ''
      // 获取登录人信息
      this.$axios.get('/auth-api/users/loginUserInfo').then(data => {
        deptId = data.data.departmentId || ''
        postId = data.data.postId || ''
        // 加载登录人姓名
        this.update(data.data.name)
        // 加载登录人工号
        if (this.component.properties.loginUser.jobNum) {
          this.update({value: data.data.jobNum || '', componentId: this.component.properties.loginUser.jobNum})
        }
      }).then(() => {
        // 获取部门名
        if (deptId && this.component.properties.loginUser.department) {
          this.$axios.get(`/auth-api/departments/${deptId}`).then(res => {
            // 加载登录人部门名称
            this.update({value: res.data.name || '', componentId: this.component.properties.loginUser.department})
          })
        }
        // 获取岗位名
        if (postId && this.component.properties.loginUser.post) {
          this.$axios.get(`/auth-api/posts/${postId}`).then(res => {
            // 加载登录人岗位名称
            this.update({value: res.data.name || '', componentId: this.component.properties.loginUser.post})
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-login-user.vue